<template>
  <div style="height: 100%;background-color: white">菜谱管理</div>
</template>

<script>
export default {
  name: 'menuManagement'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/menuManagement.vue